import type { ReactNode } from "react"

export type TranslationAddObjectsStepProps = {
  number: number
  title: string
  enabled?: boolean
  children: ReactNode
}

// One numbered step section. `enabled` greys the card out until the previous
// step unlocks it, so the order of operations is visible at a glance.
function TranslationAddObjectsStep(props: TranslationAddObjectsStepProps) {
  const { number, title, enabled = true, children } = props
  return (
    <section
      className={
        enabled
          ? "translation-addobjects-step"
          : "translation-addobjects-step translation-addobjects-step-disabled"
      }
    >
      <h3 className="translation-addobjects-step-title">
        <span className="translation-addobjects-step-number">{number}</span>
        {title}
      </h3>
      {children}
    </section>
  )
}

export default TranslationAddObjectsStep
